// Мок для страницы каталога (https://dev.trend.nasonov.fun/catalog)
// Просто импортируй этот файл и подставь данные в CatalogPage

import { CatalogResponse } from "../domain/types";

export const mockCatalog: CatalogResponse = {
  total: 3,
  page: 1,
  page_size: 20,
  total_pages: 1,
  items: [
    {
      username: "eco_blogger",
      name: "Ирина Зеленая",
      profile_picture_url: "https://randomuser.me/api/portraits/women/44.jpg",
      followers_count: 15800,
      avg_er: 4.2,
      avg_plays_per_reel: 12000,
      last_report_date: "2026-05-30",
      catalog_message: "Экоблогер, рассказываю про осознанную моду и эко-привычки."
    },
    {
      username: "fit_mama",
      name: "Мария Спорт",
      profile_picture_url: "https://randomuser.me/api/portraits/women/65.jpg",
      followers_count: 23400,
      avg_er: 3.7,
      avg_plays_per_reel: 18500,
      last_report_date: "2026-05-28",
      catalog_message: "Фитнес для мам, мотивация и лайфхаки для здоровья."
    },
    {
      username: "travel_guy",
      name: "Александр Мир",
      profile_picture_url: "https://randomuser.me/api/portraits/men/32.jpg",
      followers_count: 41200,
      avg_er: 2.9,
      avg_plays_per_reel: 22000,
      last_report_date: "2026-05-25",
      catalog_message: "Путешествия по России и миру, честные обзоры и советы."
    }
  ]
};
